import { OrderDetailsPage } from '@apps-common/apps/portal/pages/orders/pages/details/Index'

export const OrderDetails = () => <OrderDetailsPage />
